module.exports = __webpack_public_path__ + "237a7f3b2a5860f0fe098c80be9b0595.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/browsers/safari.svg
// module id = Xc0S
// module chunks = 27